// removed by extract-text-webpack-plugin
module.exports = {"base":"Back_base--xbjPm","base__left":"Back_base__left--3ZXTj","baseLeft":"Back_base__left--3ZXTj","base__right":"Back_base__right--21AmG","baseRight":"Back_base__right--21AmG","base__back":"Back_base__back--2Ej9C","baseBack":"Back_base__back--2Ej9C","base__close":"Back_base__close--RNDPr","baseClose":"Back_base__close--RNDPr","icon":"Back_icon--3e5tl","base__info":"Back_base__info--1ZcxY","baseInfo":"Back_base__info--1ZcxY","caption":"Back_caption--2L3CJ","base__cn":"Back_base__cn--kHaYB","baseCn":"Back_base__cn--kHaYB"};


//////////////////
// WEBPACK FOOTER
// ./components/Back/Back.scss
// module id = 2085
// module chunks = 11